var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field_container"},[(_vm.label)?_c('div',{staticClass:"question_name",domProps:{"textContent":_vm._s(_vm.label)}}):_vm._e(),_c('div',{staticClass:"question_field"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }